import React from 'react';
import styled from 'styled-components';
import styles from './Gallery.module.scss'
import SideBar from './components/SideBar';
import shadows from './shadows.png';
import lakes from './lakes.png';
import yellow from './yellow.png';
import balloons from './balloons.png';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

const data = {
  'yellow': {
    image: yellow,
    title: 'yellow',
    subtitle: 'yellow',
    text: 'yellow',
    previous: '/images/shadows',
    next: '/images/lakes',
    sm: 6, md: 3, lg: 2
  },
  'lakes': {
    image: lakes,
    title: 'lakes',
    subtitle: 'lakes',
    text: 'lakes',
    previous: '/images/yellow',
    next: '/images/shadows',
    sm: 6, md: 3, lg: 2
  },
  'shadows': {
    image: shadows,
    title: 'shadows',
    subtitle: 'shadows',
    text: 'shadows',
    previous: '/images/lakes',
    next: '/images/balloons',
    sm: 6, md: 3, lg: 2
  },

  'balloons': {
    image: balloons,
    title: 'balloons',
    subtitle: 'balloons',
    text: 'balloons',
    previous: '/images/shadows',
    next: '/images/yellow',
    sm: 12, md: 6, lg: 4
  }
}

export const Gallery = (props) => (
  <div>
    <Container className={styles.gallery}>
      <Row>
        {Object.values(data).map(item => (
          <Col sm={item.sm} md={item.md} lg={item.lg}>
            <Link className="menu-item" to={"/images/"+item.title}>
              <img className={styles.galleryimage} src={item.image}></img>        
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  </div>
)

